module.exports = __webpack_public_path__ + "img/bfmtv-17012022.6fb769dc.png";